<template>
  <div class="container">
    <CreateLesson :show="openmodaleasson" @open-tab="atualizarValorNoFilho" :moduleId="idMoule" :lastOrder="classes.length" />
    <EditLeasson :show="openmodalEdit" @open-tab="atualizarValorNoFilhoEdit" :data="objEditUser" :moduleId="idMoule" />
    <EditModule :show="openmodalEditModule" @open-tab="atualizarValorNoFilhoEditModule" :data="objEditModule" :moduleId="idMoule" />

    <div class="titleContainer">
      <div class="title-banner-course">
        <img src="https://www.weflix.com.br/wp-content/uploads/2024/09/logo-weflix-branco.png" alt="Weflix" />
      </div>
      <div class="title-content">
        <h3>{{currentCollections.comercialName}}</h3>
        <p v-html="currentCollections.shortDescription"></p>
      </div>
      <div class="title-actions">
        <button class="editCollections" @click="(()=>this.$router.push(`/admin/editar-colecao/${this.$route.params.slug}`))">
          <fa icon="fa-pencil"/>
        </button>
      </div>
      
    </div>

    <div class="new-module-button">
      <button class="btnWeflix" @click="openModalNewModule">
        <fa icon="fa-solid fa-plus" /> Novo Módulo
      </button>
    </div>

    <div class="toggle-all-modules">
      <button class="btnWeflix" @click="toggleAllModules">
        <fa :icon="allModulesOpen ? 'fa-chevron-up' : 'fa-chevron-down'"/>
        {{ allModulesOpen ? 'Fechar Todos os Módulos' : 'Abrir Todos os Módulos' }}
      </button>
    </div>

    <draggable
      :list="modules"
      :disabled="false"
      class="list-group"
      ghost-class="ghost"
      @start="dragging = true"
      @end="onDragEnd"
      handle=".drag-handle"
    >
      <template #item="{ element }">
        <div class="table-modules">
          <div class="title-table" @click="element.isOpen = !element.isOpen">
            <div class="module-header">
              <div class="drag-handle">
                <fa icon="fa-grip-vertical"/>
              </div>
              {{ element.title }}
            </div>
            <div class="module-actions">
              <div @click.stop="openModalEditModulue(idMoule, nameModule)" class="btn-action">
                <fa icon="fa fa-pencil"/>
              </div>
              <div @click.stop="openmodalleasson()" class="btn-action">
                <fa icon="fa-solid fa-plus"/> Nova Atividade
              </div>
              <div class="btn-action">
                <fa :icon="element.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"/>
              </div>
            </div>
          </div>

          <draggable
            v-show="element.isOpen"
            :list="element.lessons"
            :disabled="false"
            ghost-class="ghost"
            @start="draggingLesson = true"
            @end="onDragEndLesson"
            handle=".drag-handle"
          >
            <template #item="{ element: lesson}">
              <div class="lesson-row">
                <div class="lesson-content">
                  <div class="drag-handle">
                    <fa icon="fa-grip-vertical"/>
                  </div>
                  <span class="lesson-icon">
                    <fa :icon="getLessonIcon(lesson.type)" />
                  </span>
                  {{ lesson.title }}
                </div>
                <div @click="openModalEdit(lesson.id, lesson.title, lesson.type, lesson.name, lesson.quiz, idMoule)"
                  class="btn-action">
                  <fa icon="fa fa-pencil"/>
                </div>
              </div>
            </template>
          </draggable>

        </div>
      </template>
    </draggable>

  </div>
</template>

<script>
import CreateLesson from './createlesson.vue'
import EditLeasson from './editlesson.vue'
import EditModule from './editmodule.vue'
import { mapState } from 'vuex'
import ApiLesson from '@/utils/lesson'
import ApiModules from '@/utils/modules'
import draggable from 'vuedraggable'

export default {
  data() {
    return {
      name: 'Nome do Curso',
      modules: 'Modulo 1',
      itemRemove: '',
      classes: [],
      openmodaleasson: false,
      active: false,
      openmodalEdit: false,
      objEditUser: [],
      objEditModule:[],
      openmodalEditModule: false,
      modules: [],
      dragging: false,
      draggingLesson: false,
      allModulesOpen: true
    };
  },
  props: {
    idMoule: Number,
    nameModule: String,
    isFirstIteration: Boolean,
    indexModule:Number,
    manyModules:Boolean
  },
  computed: {
    ...mapState(['typeId', 'isAuthenticated', 'token', 'websites','currentCollections'])
  },
  components: {
    CreateLesson,
    EditLeasson,
    EditModule,
    draggable
  },
  methods: {
    getLessonIcon(type) {
      const icons = {
        1: 'fa-solid fa-play-circle',
        2: 'fa-solid fa-file-pdf',
        3: 'fa-solid fa-video',
        4: 'fa-solid fa-question-circle',
        5: 'fa-solid fa-video'
      }
      return icons[type]
    },
    toggleAllModules() {
      this.allModulesOpen = !this.allModulesOpen;
      this.modules.forEach(module => {
        module.isOpen = this.allModulesOpen;
      });
    },
    openModalNewModule() {
      this.$emit('open-new-module');
    },
    async onDragEnd(evt) {
      this.dragging = false;
      try {
        const moduleId = evt.item.id;
        const newIndex = evt.newIndex;
        
        await ApiModules.editModule({
          order: newIndex
        }, this.token, moduleId);
        
        await this.getModules();
      } catch (error) {
        console.error('Erro ao atualizar ordem dos módulos:', error);
      }
    },
    async onDragEndLesson(evt) {
      this.draggingLesson = false;
      try {
        const lessonId = evt.item.id;
        const newIndex = evt.newIndex;

        await ApiLesson.editLesson({
          order: newIndex  
        }, this.token, lessonId);

        await this.getLesson(this.token);
      } catch (error) {
        console.error('Erro ao atualizar ordem das lições:', error);
      }
    },
    moveUpModule(){
      this.$emit('moveUp')
    },
    moveDownModule(){
      this.$emit('moveDown');
    },
    async getLesson(token) {
      try {
        const response = await ApiLesson.getDataLessonByModule(this.idMoule, token);
        this.classes = response.content.sort((a, b) => a.order - b.order);
      } catch (err) {
        console.error("Erro ao carregar as lesson", err)
      }
    },
    openmodalleasson() {
      this.openmodaleasson = !this.openmodaleasson;
    },
    openModalEdit(id, leasson, type, name, quiz) {
      const data = {
        'id': id,
        'leasson': leasson,
        'type': type,
        'name': name,
        'quiz': quiz,
        'moduleId': this.idMoule
      }
      this.objEditUser = data;

      this.openmodalEdit = true;
    },
    openModalEditModulue(id, name) {
      const data = {
        'id': id,
        'name': name
      }
      this.objEditModule = data;

      this.openmodalEditModule = true;
    },
    atualizarValorNoFilho(novoValor) {
      this.openmodaleasson = false;
    },
    atualizarValorNoFilhoEdit(novoValor) {
      this.openmodalEdit = false;
    },
    atualizarValorNoFilhoEditModule(novoValor) {
      this.openmodalEditModule = false;
    },
    hideContent() {
      this.active = !this.active
    },
    async moveUp(index, id) {
      if (index > 0) {
        try {
          const response = await ApiLesson.moveDown(this.token, id);
          this.getLesson(this.token)
          console.debug( response);
        } catch (error) {
          console.error(error);
        }
      }
        
    },
    async moveDown(index, id) {
      if (index < this.classes.length - 1) {
        try {
          const response = await ApiLesson.moveUp(this.token, id);
          this.getLesson(this.token)
          console.debug( response);
        } catch (error) {
          console.error(error);
        }
      }
    },
    async getModules(){
      try {
        const response = await ApiModules.getDataModulesAndLessonsByCourse(this.currentCollections.id, this.token);
        this.modules = response.sort((a, b) => a.order - b.order).map(module => ({
          ...module,
          isOpen: true
        }));
      } catch (error) {
        console.error(error);
      }
    }
  },
  mounted() {
    this.active = this.isFirstIteration;
  },
  created() {
    this.getModules();
  },
  watch: {
    openmodaleasson(newValue) {
      setTimeout(() => {
        this.getLesson(this.token);
      }, 1000);
    },
    openmodalEdit(newValue) {
      setTimeout(() => {
        this.getLesson(this.token);
      }, 1000);
    },
    openmodalEditModule(newValue) {
      setTimeout(() => {
        this.$emit('open-tab-modules');
      }, 1000);
     
    },
  }
};
</script>

<style scoped>
.container {
  max-width: 100%;
  background-color: white;
  padding: 10px 0 50px;
}

.titleContainer {
  display: block;
  text-align: left;
  padding: 0 10px;
  border-bottom: 1px solid #e8e8e8;
  margin: 10px;
}

.editCollections {
  padding: 8px 16px;
  border-radius: 4px;
  background: #fff;
  border: 1px solid #250891;
  color: #250891;
  transition: all 0.3s;
}

.editCollections:hover {
  background: #250891;
  color: #fff;
}

.toggle-all-modules {
  padding: 20px;
  text-align: right;
}

.table-modules {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin: 20px;
  overflow: hidden;
}

.title-table {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
}

.module-header {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 1.1em;
  font-weight: 500;
}

.module-actions {
  display: flex;
  gap: 15px;
}

.drag-handle {
  cursor: move;
  color: #6c757d;
  padding: 5px;
  border-radius: 4px;
}

.drag-handle:hover {
  background: #e9ecef;
}

.lesson-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px 15px 40px;
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.2s;
}

.lesson-row:hover {
  background-color: #f8f9fa;
}

.lesson-content {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.lesson-icon {
  color: #6c757d;
  width: 20px;
  text-align: center;
}

.btn-action {
  padding: 6px;
  cursor: pointer;
  color: #6c757d;
  border-radius: 4px;
  transition: all 0.2s;
}

.btn-action:hover {
  color: #000;
  background: #e9ecef;
}

.ghost {
  opacity: 0.5;
  background: #e3f2fd !important;
  border: 2px dashed #90caf9;
}

.btnWeflix {
  padding: 8px 16px;
  border-radius: 4px;
  background: #fff;
  border: 1px solid #250891;
  color: #250891;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.btnWeflix:hover {
  background: #250891;
  color: #fff;
}

.new-module-button {
  margin: 20px;
  text-align: right;
}

@media (max-width: 600px) {
  .module-actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .btnWeflix {
    width: 100%;
    justify-content: center;
  }
}
</style>
